// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1Epti","amount":"Amount_amount__3CjaJ","tip":"Amount_tip__3F32R","tipHeader":"Amount_tipHeader__3w12N","tipsWrap":"Amount_tipsWrap__1Ldi7"};